import React, { memo } from "react";

import "./section.m.css";

function CricketWidget() {
  return (
    <div styleName="cricket-widget-wrapper">
      <div styleName="sponsor-logo">
        <img src="https://images.assettype.com/gulfnews/2025-12-04/5lw183yn/DPWORLD-ILT20-2X.png" width={190} />
      </div>
      <div
        data-wdtype="fixtures"
        data-viewtype="strip"
        data-matchstate="LUR"
        data-matchorder="LUR"
        data-count="R-20,U-20"
        data-year="2025"
        data-tour-ids="9972"
        data-series-ids="13222"
        data-lang="en"
        data-wdid="1"
        className="si-widget si-component si-scorestrip"
      ></div>
      <script async src="https://assets-gulfnews.sportz.io/static-assets/build/js/gulfnews-init.js?v=3"></script>
    </div>
  );
}
export default memo(CricketWidget);
